import script from "./HistoricoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoricoComponent.vue?vue&type=script&setup=true&lang=js"

import "./HistoricoComponent.vue?vue&type=style&index=0&id=4ff0386d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff0386d"]])

export default __exports__